export { FAQSideBySide, type FAQSideBySideProps } from "./FAQSideBySide";
